import { NgClass, NgForOf, NgIf } from '@angular/common';
import { Component, ElementRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import { TlPagination } from 'src/app/interfaces/general-interfaces';
import { SearchHttpService } from 'src/app/services/http-services/search/search-http.service';
import { ListersComponent } from '../listers/listers.component';
import { CompaniesComponent } from '../companies/companies.component';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {UserRoles} from '../../../../../enums/general-enums';
import {CheckActiveRoleModule} from '../../../../../pipes/check-active-role/check-active-role.module';

@Component({
  selector: 'app-accounts',
  standalone: true,
  imports: [NgIf, NgClass, NgForOf, ListersComponent, CompaniesComponent, RouterModule, TranslateModule, CheckActiveRoleModule],
  templateUrl: './accounts.component.html',
})
export class AccountsComponent {
  @Input() searchTerm = '';
  @Input() isLiveSearch = false;
  tabSelected: string = 'all';
  listers: any[] = [];
  companies: any[] = [];
  PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(
    private searchHttpService: SearchHttpService
  ) { }

  ngOnInit(): void {
    // this.getAccounts();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.getAccounts();
    }
  }

  getAccounts(): void {
    this.searchHttpService.formattedGetAccountsResults(this.isLiveSearch,this.searchTerm).then((response: any) => {
      this.companies = response.data.companies;
      this.listers = response.data.users;
    })
  }

  protected readonly UserRoles = UserRoles;
}
